import React from 'react';
import styles from '../Settings.module.css';

const PrivacyTab: React.FC = () => {
  return (
    <div className={styles.tabContent}>
      <div className={styles.sectionHeader}>
        <h3>Privacy & Data</h3>
        <p className={styles.sectionDescription}>
          Learn about how we protect your privacy and handle your dietary data.
        </p>
      </div>

      <div className={styles.privacyContent}>
        <div className={styles.privacySection}>
          <h4>Data Collection</h4>
          <p>We collect only the dietary and health information you choose to share with us. This includes your dietary preferences, health concerns, and ingredient preferences.</p>
        </div>

        <div className={styles.privacySection}>
          <h4>Data Usage</h4>
          <p>Your data is used solely to provide personalized recipe recommendations and dietary insights. We never sell your personal information to third parties.</p>
        </div>

        <div className={styles.privacySection}>
          <h4>Data Sharing</h4>
          <p>Your dietary preferences are only shared with venues when you explicitly choose to do so (e.g., by scanning a QR code or using your Digital ID). You control what information is shared.</p>
        </div>

        <div className={styles.privacySection}>
          <h4>Data Security</h4>
          <p>All your data is encrypted and stored securely. We use industry-standard security measures to protect your information.</p>
        </div>

        <div className={styles.privacySection}>
          <h4>Your Rights</h4>
          <p>You have the right to access, modify, or delete your data at any time through your account settings.</p>
        </div>
      </div>
    </div>
  );
};

export default PrivacyTab;
